import React, { useEffect, useState } from 'react';
import { BottleRatingReview } from '../../../components/review/Bottle';
import Rater from '../../../components/review/Rater';
import css from './SearchSortBy.module.css';

const SortByOtherCriteria = ({
  handleOnChangeLocalfruit,
  setReservationsRequired,
  setDogsFriendly,
  setKidsFriendly,
  wineries,
  setWineriesToDisplay,
  dogFriendly,
  kidsFriendly,
  reservationsRequired,
  qualityScore,
  setQualityScore,
  varietyScore,
  setVarietyScore,
  ambianceScore,
  setAmbianceScore,
  affordableScore,
  setAffordableScore,
  customerServiceScore,
  setCustomerServiceScore,
  foodOfferingsScore,
  setFoodOfferingsScore,
  selected,
}) => {

  return (
    <div>
      <h3>Other Criteria</h3>
      <div>
        <div>
          <span className={css.filterByReview}>
            Wine Quality:{' '}
            <Rater score={qualityScore} setScore={setQualityScore} uniqId="winequality" />
          </span>
          <span className={css.filterByReview}>
            Wine Variety:{' '}
            <Rater score={varietyScore} setScore={setVarietyScore} uniqId="winevariety:" />
          </span>
          <span className={css.filterByReview}>
            Venue Ambiance:{' '}
            <Rater score={ambianceScore} setScore={setAmbianceScore} uniqId="venueambiance:" />
          </span>
          <span className={css.filterByReview}>
            Affordable:{' '}
            <Rater score={affordableScore} setScore={setAffordableScore} uniqId="affordable:" />
          </span>
          <span className={css.filterByReview}>
            Food Offerings:{' '}
            <Rater
              score={foodOfferingsScore}
              setScore={setFoodOfferingsScore}
              uniqId="foodofferings:"
            />
          </span>
          <span className={css.filterByReview}>
            Customer Service:{' '}
            <Rater
              score={customerServiceScore}
              setScore={setCustomerServiceScore}
              uniqId="customerservice:"
            />
          </span>
        </div>
      </div>
      <div style={{ marginTop: '20px', padding: '20px 0', borderTop: '1px solid #F2F1EF' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <input
            type="checkbox"
            id="kidFriendly"
            name="kidFriendly"
            onChange={(e) => setKidsFriendly(e.target.checked)}
            checked={kidsFriendly}
            style={{ display: 'inline-block', width: 'auto', marginRight: '10px' }}
          />
          <label htmlFor="kidFriendly">Kids Friendly</label>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <input
            type="checkbox"
            id="dogFriendly"
            name="dogFriendly"
            onChange={(e) => setDogsFriendly(e.target.checked)}
            checked={dogFriendly}
            style={{ display: 'inline-block', width: 'auto', marginRight: '10px' }}
          />
          <label htmlFor="dogFriendly">Dog Friendly</label>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <input
            type="checkbox"
            id="reservationsRequired"
            name="reservationsRequired"
            checked={reservationsRequired}
            onChange={(e) => setReservationsRequired(e.target.checked)}
            style={{ display: 'inline-block', width: 'auto', marginRight: '10px' }}
          />
          <label htmlFor="reservationsRequired">Reservations Required</label>
        </div>
      </div>
    </div>
  );
};

export default SortByOtherCriteria;
